import { render, staticRenderFns } from "./excursion-demo.vue?vue&type=template&id=d77f609c&"
import script from "./excursion-demo.vue?vue&type=script&lang=ts&"
export * from "./excursion-demo.vue?vue&type=script&lang=ts&"
import style0 from "./excursion-demo.vue?vue&type=style&index=0&id=d77f609c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports